import { toast } from "sonner";
import { trpc } from "@/lib/trpc";

export async function downloadAttachment(utils: ReturnType<typeof trpc.useUtils>, fileId: string) {
  try {
    const { url } = await utils.file.getDownloadUrl.fetch({ fileId });
    window.open(url, "_blank", "noopener,noreferrer");
  } catch {
    toast.error("Não foi possível baixar o arquivo.");
  }
}

export type ActiveMember = { user: { id: string; name: string | null; email: string } };
export type Stage = { id: string; label: string; colorHex: string | null };

/**
 * Mutations e catálogos da Produção, compartilhados entre a tabela (desktop) e a lista (celular).
 * As invalidações são a parte que importa manter única: setStatus e setProductionStage mexem no
 * rollup do pedido "por baixo" via resolver, então invalidam os dois lados + contadores do
 * dashboard, não só a lista de produção do laboratório.
 */
export function useProductionMutations() {
  const utils = trpc.useUtils();

  const setStatus = trpc.prosthesis.incoming.setStatus.useMutation({
    onSuccess: () => {
      utils.prosthesis.incoming.list.invalidate();
      utils.prosthesis.incoming.getById.invalidate();
      utils.prosthesis.list.invalidate();
      utils.prosthesis.countByStatus.invalidate();
    },
  });
  const setAssignedTo = trpc.prosthesis.incoming.setAssignedTo.useMutation({
    onSuccess: () => utils.prosthesis.incoming.list.invalidate(),
  });
  const setModelStage = trpc.prosthesis.incoming.setModelStage.useMutation({
    onSuccess: () => utils.prosthesis.incoming.list.invalidate(),
  });
  const setProductionStage = trpc.prosthesis.incoming.setProductionStage.useMutation({
    onSuccess: () => {
      utils.prosthesis.incoming.list.invalidate();
      utils.prosthesis.incoming.getById.invalidate();
      utils.prosthesis.list.invalidate();
      utils.prosthesis.countByStatus.invalidate();
    },
  });

  const stagesQuery = trpc.prosthesis.stages.list.useQuery();
  const modelStagesQuery = trpc.prosthesis.modelStages.list.useQuery();
  const teamQuery = trpc.team.list.useQuery();

  return {
    utils,
    setStatus,
    setAssignedTo,
    setModelStage,
    setProductionStage,
    stages: (stagesQuery.data ?? []) as Stage[],
    modelStages: (modelStagesQuery.data ?? []) as Stage[],
    activeMembers: ((teamQuery.data ?? []) as ActiveMember[]).filter((m: any) => m.status === "ACTIVE"),
  };
}
